import React, { useState, useEffect } from "react";
import { colors } from "../utils/theme.js";
import { api } from "../api/client.js";
import { inputStyle, primaryBtn, ghostBtn } from "../clients/ui.js";

// Import a template — stamps a new objective + tasks. Used from a client's objectives section
// (clientId + projectId set) and for internal objectives (both null). Reusable across pages.
export default function ImportTemplate({ clientId = null, projectId = null, contextLabel, onClose, onImported }) {
  const [templates, setTemplates] = useState([]);
  const [templateId, setTemplateId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [includeOptional, setIncludeOptional] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => { api.templates.list().then((t) => setTemplates(t || [])).catch(() => setTemplates([])); }, []);
  const selected = templates.find((t) => t.id === templateId);
  const selectedTasks = selected?.tasks || [];
  const optionalCount = selectedTasks.filter((t) => t.optional === true).length;
  const importCount = includeOptional ? selectedTasks.length : selectedTasks.length - optionalCount;

  const doImport = async () => {
    if (!templateId || !startDate || busy) return;
    setBusy(true); setError(null);
    const res = await api.templates.import(templateId, { clientId, projectId, startDate, includeOptional });
    setBusy(false);
    if (res.ok) onImported(res.data);
    else setError(res.data?.error || "Import failed.");
  };

  const L = ({ children }) => <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: 0.6, color: colors.textDim, margin: "12px 0 4px" }}>{children}</div>;
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 1100, display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(4px)" }} onClick={onClose}>
      <div style={{ width: 460, maxWidth: "92vw", background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: 16, padding: 26 }} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 4px", fontSize: 18, fontWeight: 700, color: colors.text }}>Import a template</h2>
        <div style={{ fontSize: 12, color: colors.textDim }}>{contextLabel || (clientId ? "Onto this client" : "As an internal objective")}</div>

        <L>Template</L>
        <select style={inputStyle} value={templateId} onChange={(e) => setTemplateId(e.target.value)}>
          <option value="">Select a template</option>
          {templates.map((t) => <option key={t.id} value={t.id}>{t.name} ({(t.tasks || []).length} tasks)</option>)}
        </select>

        <L>Objective start date</L>
        <input type="date" style={inputStyle} value={startDate} onChange={(e) => setStartDate(e.target.value)} />

        {optionalCount > 0 && (
          <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 14, fontSize: 13, color: colors.textMuted, cursor: "pointer", userSelect: "none" }}>
            <input type="checkbox" checked={includeOptional} onChange={(e) => setIncludeOptional(e.target.checked)} />
            Include optional tasks ({optionalCount})
          </label>
        )}

        {selected && (
          <div style={{ fontSize: 12, color: colors.textMuted, marginTop: 10 }}>
            Creates “{selected.name}” with {importCount} task(s). Working-day offsets resolve from the start date{clientId ? "; role assignees resolve to this project’s PM/owner" : " (role/client assignees import unassigned for internal work)"}.
          </div>
        )}
        {error && <div style={{ color: colors.danger, fontSize: 13, marginTop: 10 }}>{error}</div>}
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 18 }}>
          <button onClick={onClose} style={ghostBtn}>Cancel</button>
          <button onClick={doImport} disabled={!templateId || !startDate || busy} style={{ ...primaryBtn, opacity: (!templateId || !startDate || busy) ? 0.5 : 1 }}>{busy ? "Importing…" : "Import"}</button>
        </div>
      </div>
    </div>
  );
}
